
const globals = {
  state: {
    // global alerts in app.vue
    globalSuccessAlertText: '',
    globalErrorAlertText: '',
  },
  mutations: {
    setGlobalAlert(state, options) {
      if (options.error) {
        state.globalErrorAlertText = options.msg;
      } else {
        state.globalSuccessAlertText = options.msg;
      }
    },
    clearGlobalAlerts(state) {
      state.globalErrorAlertText = '';
      state.globalSuccessAlertText = '';
    },
    clearGlobalAlert(state, isError) {
      if (isError) {
        state.globalErrorAlertText = '';
      } else {
        state.globalSuccessAlertText = '';
      }
    },
  },
  actions: {

  },
  getters: {
    showGlobalSuccessAlert(state) {
      return state.globalSuccessAlertText.length > 0;
    },
    showGlobalErrorAlert(state) {
      return state.globalErrorAlertText.length > 0;
    },
    globalSuccessAlertText(state) {
      return state.globalSuccessAlertText;
    },
    globalErrorAlertText(state) {
      return state.globalErrorAlertText;
    },
  },
};

export default globals;
